import React, { FC } from 'react';
import cx from 'classnames';
import { Placeholder } from '../Placeholder/Placeholder';

type TProgressBarProps = {
  progress?: number;
  showProgressBar?: boolean;
  completed?: boolean;
  loading?: boolean;
};

export const ProgressBar: FC<TProgressBarProps> = ({ progress, showProgressBar, completed, loading }) => {
  if (loading) {
    return <Placeholder className="w-full h-[6px] rounded-[18px]" />;
  }

  return (
    <div className="w-full h-[6px] bg-t2-neutral-grey04 rounded-[18px] overflow-hidden">
      {showProgressBar && (
        <div
          style={{ width: `${progress}%` }}
          className={cx('h-full rounded-r-[18px] bg-t2-success-darkGreen', {
            '!bg-t2-neutral-grey09': completed,
          })}
        />
      )}
    </div>
  );
};
